bq.updateProductLimits = function () {
    var products = [];
    var itemIds = [];
    var pageType = $('[data-bq="product-limits"]').data('page-type');
    if (pageType !== 'checkout') {
        $('[data-bq="product-limit"]').each(function () {
            var id = $(this).data('product-id');
            if (id !== '0') {
                products.push(id);
            }

            var itemId = $(this).data('item-id');
            if (itemId !== '0') {
                itemIds.push(itemId);
            }
        });
    }

    $.ajax({
        type: "POST",
        url: bq.urls.ajax.productLimits,
        data: {
            products: products,
            type: pageType,
            itemIds: itemIds
        },
        success: bq.setProductLimits,
        dataType: 'json'
    });
};

bq.setProductLimits = function (data) {
    var $limits = $('[data-bq="product-limit"]');
    $limits.each(function () {
        var $limit = $(this),
            itemId = $limit.data('item-id'),
            itemName = $limit.data('item-name'),
            nameRegEx = new RegExp('{{limit_name}}', 'g'),
            box = '';

        if (typeof data[itemId] !== 'undefined') {
            box = data[itemId];
        } else if (typeof data[0] !== 'undefined') {
            box = data[0];
        }
        if (box != '') {
            box = box.replace(nameRegEx, itemName);
        }
        $limit.html(box);
    });
};

if ($('[data-bq="product-limit"]').length) {
    bq.updateProductLimits();
}
